import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { authService } from '../../services/authService';
import { API_BASE_URL } from '../../config/api';
import { PERMISSION_OPTIONS } from './permissionOptions';
import AddUser from './AddUser';
import EditUser from './EditUser';

import { Table, Button, Switch, Tag, Space, Card } from 'antd';
import { PlusOutlined, EditOutlined } from '@ant-design/icons';

export default class UserManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      loading: true,
      addOpen: false,
      editUser: null,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    const token = await authService.ensureValidToken();
    if (!token) {
      console.error('Not authenticated');
      return;
    }

    this.setState({ loading: true });

    axios({
      method: 'GET',
      url: `${API_BASE_URL}/connect/users?clientCode=${this.props.client.ClientCode}`,
      headers: { Authorization: `Bearer ${token}` },
    }).then(res => {
      this.setState({
        users: res.data.data,
        loading: false,
      });
    }).catch(err => {
      console.log(err);
      this.setState({ loading: false });
      toast.error(err.response?.data?.error || 'Failed to load users');
    });
  };

  toggleEnabled = async (user, enabled) => {
    const token = await authService.ensureValidToken();
    if (!token) return;

    axios({
      method: 'PUT',
      url: `${API_BASE_URL}/connect/users/${user.keycloakID}`,
      headers: { Authorization: `Bearer ${token}` },
      data: { enabled },
    }).then(res => {
      toast.success(`User ${user.username} was ${enabled ? 'enabled' : 'disabled'}`);
      this.loadData();
    }).catch(err => {
      console.log(err);
      toast.error(err.response?.data?.error || 'Failed to update user');
    });
  };

  render() {
    const mySub = authService.getUserAttributes()?.sub;

    const columns = [
      {
        title: 'Login',
        dataIndex: 'username',
        key: 'username',
      },
      {
        title: 'Name',
        key: 'name',
        render: (_, user) => [user.firstName, user.lastName].filter(Boolean).join(' '),
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Access',
        key: 'access',
        render: (_, user) => {
          const allowed = PERMISSION_OPTIONS.filter(o => user.permissions[o.key] === 1);
          return (
            <Space size={4} wrap>
              {user.isClientAdmin === 1 ? <Tag color="gold">Admin</Tag> : null}
              {allowed.length === PERMISSION_OPTIONS.length ?
                <Tag color="green">All pages</Tag> :
                allowed.length === 0 ?
                  <Tag color="red">No pages</Tag> :
                  allowed.map(o => <Tag key={o.key}>{o.label}</Tag>)
              }
            </Space>
          );
        },
      },
      {
        title: 'Enabled',
        key: 'enabled',
        render: (_, user) => (
          <Switch
            checked={user.enabled}
            disabled={user.keycloakID === mySub}
            onChange={(checked) => this.toggleEnabled(user, checked)}
          />
        ),
      },
      {
        title: '',
        key: 'actions',
        render: (_, user) => (
          <Button
            icon={<EditOutlined />}
            onClick={() => this.setState({ editUser: user })}
          >
            Edit
          </Button>
        ),
      },
    ];

    return (
      <Card
        title={`Users — ${this.props.client.ClientName} #${this.props.client.ClientCode}`}
        extra={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => this.setState({ addOpen: true })}
          >
            Add User
          </Button>
        }
      >
        <Table
          rowKey="keycloakID"
          columns={columns}
          dataSource={this.state.users}
          loading={this.state.loading}
          pagination={{ pageSize: 25, hideOnSinglePage: true }}
          scroll={{ x: true }}
        />

        <AddUser
          visible={this.state.addOpen}
          onClose={() => this.setState({ addOpen: false })}
          client={this.props.client}
          loadData={this.loadData}
        />

        {this.state.editUser ?
          <EditUser
            key={this.state.editUser.keycloakID}
            visible={true}
            onClose={() => this.setState({ editUser: null })}
            user={this.state.editUser}
            isSelf={this.state.editUser.keycloakID === mySub}
            loadData={this.loadData}
          /> : null
        }
      </Card>
    );
  }
}
